import React from "react";
import { Layout, Menu, Typography } from "antd";

import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  AccountBookFilled,
  SettingFilled,
  UploadOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
const { Header, Sider, Content } = Layout;
const { Title } = Typography;
export default class AdminLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedKey: "1",
    };
  }
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };
  componentDidMount = () => {
    var location = window.location.pathname;
    console.log({ location });
    switch (location) {
      case "/admin":
        this.setState({
          selectedKey: "1",
        });
        break;
      case "/admin/users":
        this.setState({ selectedKey: "2" });
        break;
      case "/admin/judges":
        this.setState({ selectedKey: "3" });
        break;
      default:
    }
  };

  render() {
    return (
      <Layout className="admin-layout">
        <Sider
          className="admin-layout-sider"
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
        >
          <Menu
            onSelect={(value) => {
              console.log(value);
              this.setState({ selectedKey: value.key });
            }}
            theme="dark"
            mode="inline"
            selectedKeys={this.state.selectedKey}
            defaultSelectedKeys={["1"]}
          >
            <Menu.Item key="1" icon={<UserOutlined />}>
              <Link to="/admin"> Nominations</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<UserOutlined />}>
              <Link to="/admin/users">Members</Link>
            </Menu.Item>
            <Menu.Item key="5" icon={<UserOutlined />}>
              <Link to="/admin/hotels">Hotels</Link>
            </Menu.Item>
            <Menu.Item key="3" icon={<UploadOutlined />}>
              <Link to="/admin/judges">Judges</Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<UploadOutlined />}>
              <Link to="/admin/finalist">Finalist</Link>
            </Menu.Item>
            <Menu.Item key="6" icon={<SettingFilled />}>
              <Link to="/admin/settings">Settings</Link>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header
            className="site-layout-background admin-layout-header"
            // style={{ paddingLeft: "20px" }}
          >
            <div className="admin-layout-header-inner">
              <div>
                {React.createElement(
                  this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,

                  {
                    className: "trigger",
                    style: { paddingRight: "5px" },
                    onClick: this.toggle,
                  }
                )}
              </div>

              {/* <div style={{ marginTop: "16px", marginLeft: "2px" }}> */}
              <Title className="admin-layout-title" level={4}>
                Big Apple Stars Awards Nomination
              </Title>
              {/* </div> */}
            </div>
          </Header>
          <Content className="site-layout-admin">{this.props.children}</Content>
        </Layout>
      </Layout>
    );
  }
}
